import {NativeDateAdapter} from "@angular/material/core";
import {Injectable} from "@angular/core";
import {ProjectUtils} from "../project-utils";

@Injectable()
export class CustomNativeDateAdapter extends NativeDateAdapter {

  /*override*/
  format(date: Date, displayFormat: Object): string {

    if (displayFormat === 'input') {

      let day = Number(date.getDate());
      let dayStr: string, monthStr: string;
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      if (day < 10) {
        dayStr = '0' + day;
      } else {
        dayStr = day.toString();
      }

      if (month < 10) {
        monthStr = '0' + month;
      } else {
        monthStr = month.toString();
      }

      return `${dayStr}-${monthStr}-${year}`;
    }

    return date.toDateString();
  }

  parse(value: string): Date | null {
    let inputFormatStr = '';
    if (value.includes('/')) {
      inputFormatStr = 'DD/MM/YYYY';
    } else if (value.includes('-')) {
      inputFormatStr = 'DD-MM-YYYY';
    }
    const dateObj = ProjectUtils.getDayJSDateObject(value, inputFormatStr);
    return dateObj.isValid() ? dateObj.toDate() : this.invalid();
  }

  getFirstDayOfWeek(): number {
    return 1;
  }
}

export const CUSTOM_NATIVE_DATE_FORMATS =
  {
    parse: {
      dateInput: {month: 'short', year: 'numeric', day: 'numeric'},
    },
    display: {
      dateInput: 'input',
      monthYearLabel: {year: 'numeric', month: 'numeric'},
      dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
      monthYearA11yLabel: {year: 'numeric', month: 'long'},
    }
  };
